import _defineProperty from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import Tooltip from "../../../Tooltip";
import { useToken } from "../../../../hooks/useToken";
import { BestBuyStatus, BestBuyTradeStatus } from "../../../../hooks/useUserBestBuyList";
import { CancelButton, OrderStatus, Row, StyledOrder, StyledTokens, StyledTradingPairWrapper, DetailButton, ButtonsWrapper, StyledYield } from "./styled";
import { formatUnits } from 'ethers/lib/utils';
import { useTokenBalance } from "../../../../state/wallet/hooks";
import { useWeb3React } from '@web3-react/core';
import { useMemo } from 'react';
import { useUpdaterChainId } from "../../../../hooks";
import { useBestBuyTokens } from "../../../../state/dex/hooks";
import { useTokenPrice } from "../../../../hooks/useTokenPrice";
import { useCancelBestBuyOrder } from "../../hooks/useCancelBestBuyOrder";
import IconOrderArrow from "../../../../assets/images/order-arrow.svg";
import IconQuestionMark from "../../../../assets/images/question-mark-gray.svg";
import IconExclamationMark from "../../../../assets/images/exclamation_mark_red.svg";

var formattedAmount = function formattedAmount(amount) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  return new BigNumber(amount).toFormat(decimals).replace(/\.?0+$/, '');
};

var Order = _ref => {
  var order = _ref.order,
      handleOpenOrderDetail = _ref.handleOpenOrderDetail;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var expiry = order.expiry,
      createdAt = order.createdAt,
      status = order.status,
      outputTokenAddr = order.dealerToken,
      inputTokenAddr = order.userToken,
      _order$dealerTokenAmo = order.dealerTokenAmount,
      outputTokenAmount = _order$dealerTokenAmo === void 0 ? '0' : _order$dealerTokenAmo,
      _order$userTokenAmoun = order.userTokenAmount,
      inputTokenAmount = _order$userTokenAmoun === void 0 ? '0' : _order$userTokenAmoun,
      _order$trades = order.trades,
      trades = _order$trades === void 0 ? [] : _order$trades,
      _order$filledUserAmou = order.filledUserAmount,
      filledUserAmount = _order$filledUserAmou === void 0 ? '0' : _order$filledUserAmou,
      _order$filledDealerAm = order.filledDealerAmount,
      filledDealerAmount = _order$filledDealerAm === void 0 ? '0' : _order$filledDealerAm,
      _order$remainQuota = order.remainQuota,
      remainQuota = _order$remainQuota === void 0 ? '0' : _order$remainQuota;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var expectChainId = useUpdaterChainId();
  var outputTokenOnChain = useToken(outputTokenAddr);
  var inputTokenOnChain = useToken(inputTokenAddr);
  var bestBuyTokens = useBestBuyTokens(expectChainId);
  var inputToken = useMemo(() => {
    return inputTokenOnChain ? inputTokenOnChain : bestBuyTokens[inputTokenAddr];
  }, [inputTokenOnChain, bestBuyTokens]);
  var outputToken = useMemo(() => {
    return outputTokenOnChain ? outputTokenOnChain : bestBuyTokens[outputTokenAddr];
  }, [outputTokenOnChain, bestBuyTokens]);
  var userInputBalance = useTokenBalance(account, inputToken);
  var outputPrice = useTokenPrice(outputToken === null || outputToken === void 0 ? void 0 : outputToken.address);
  var cancelOrder = useCancelBestBuyOrder();
  var outputAmount = formatUnits(outputTokenAmount, outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
  var inputAmount = formatUnits(inputTokenAmount, inputToken === null || inputToken === void 0 ? void 0 : inputToken.decimals).toString();
  var filledOutputAmount = formatUnits(filledDealerAmount, outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
  var filledInputAmount = formatUnits(filledUserAmount, inputToken === null || inputToken === void 0 ? void 0 : inputToken.decimals).toString();
  var isInProgress = status === BestBuyStatus.Pending || status === BestBuyStatus.PartialFilled;
  var now = dayjs();
  var expiryDate = dayjs.unix(expiry);
  var totalDays = Math.ceil(expiryDate.diff(createdAt, 'day', true));
  var remainingDays = isInProgress ? Math.ceil(expiryDate.diff(now, 'day', true)) : 0;
  var executionDays = Math.ceil(expiryDate.diff(createdAt, 'day', true));
  var currentYield = useMemo(() => {
    if (!Number(outputPrice) || !Number(filledUserAmount) || !Number(filledDealerAmount)) return '0';
    var currentAveragePrice = new BigNumber(filledInputAmount).div(filledOutputAmount);
    var result = new BigNumber(outputPrice).div(currentAveragePrice).minus(1).multipliedBy(100);
    return formattedAmount(result, 1);
  }, [outputPrice, filledInputAmount, filledOutputAmount]);
  var targetRate = useMemo(() => {
    var result = new BigNumber(inputAmount).div(outputAmount);
    return formattedAmount(result);
  }, [inputAmount, outputAmount]);
  var averageAmount = useMemo(() => {
    var result = new BigNumber(inputAmount).div(executionDays);
    return formattedAmount(result);
  }, [inputAmount, executionDays]);
  var isInputBalanceEnough = useMemo(() => {
    if (!userInputBalance || userInputBalance.isZero()) return false;
    return userInputBalance.gte(remainQuota);
  }, [userInputBalance, remainQuota]);
  var isInsufficientStatus = !isInputBalanceEnough && isInProgress;
  var formattedStatus = isInsufficientStatus ? BestBuyStatus.Insufficient : status;

  var addMissingRecords = (startTime, endTime, trades) => {
    var startDate = dayjs(startTime);
    var endDate = dayjs.unix(endTime);
    var updatedEndDate = now.isAfter(endDate, 'day') ? endDate : now;
    var formattedTrades = [...trades];

    var _loop = function _loop(date) {
      var dateString = date.toISOString();
      var hasTrade = trades.some(trade => {
        var tradeDate = dayjs(trade.createdAt);
        return tradeDate.isSame(date, 'day');
      });

      if (!hasTrade) {
        if (date.isSame(updatedEndDate, 'day') && !now.isAfter(now.endOf('day'))) return "break";
        formattedTrades.push({
          createdAt: dateString,
          status: BestBuyTradeStatus.NotReached
        });
      }
    };

    for (var date = startDate; !date.isAfter(updatedEndDate, 'day'); date = date.add(1, 'day')) {
      var _ret = _loop(date);

      if (_ret === "break") break;
    }

    return formattedTrades;
  };

  var formattedTrades = addMissingRecords(createdAt, expiry, trades);

  var formattedOrder = _objectSpread(_objectSpread({}, order), {}, {
    trades: formattedTrades
  });

  var disableDetailButton = formattedTrades.length === 0;
  return __jsx(StyledOrder, null, __jsx(StyledTokens, null, __jsx(StyledTradingPairWrapper, null, inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol, __jsx("img", {
    src: IconOrderArrow,
    className: "arrow-right"
  }), outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol), __jsx(OrderStatus, {
    className: formattedStatus
  }, t("best_buy_status_".concat(formattedStatus)), formattedStatus === BestBuyStatus.Insufficient && __jsx(Tooltip, {
    overlayClassName: "limit-order-tooltip",
    placement: "topLeft",
    title: t('best_buy_trade_status_insufficient'),
    trigger: "hover",
    img: IconExclamationMark
  }))), __jsx(Row, null, __jsx("div", {
    className: "label"
  }, t('order_roi'), __jsx(Tooltip, {
    overlayClassName: "limit-order-tooltip",
    placement: "topLeft",
    title: t('order_roi_tip'),
    trigger: "hover",
    img: IconQuestionMark
  })), __jsx(StyledYield, {
    color: parseFloat(currentYield) < 0 ? '#e75b55' : parseFloat(currentYield) > 0 ? '#6bc7a1' : '#2C2842'
  }, "".concat(currentYield, "%"))), __jsx(Row, null, __jsx("div", {
    className: "label"
  }, t('order_time')), __jsx("div", {
    className: "value"
  }, dayjs(createdAt).format('YYYY-MM-DD'))), __jsx(Row, null, __jsx("div", {
    className: "label"
  }, t('trigger_price_with_token', {
    token: outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol
  })), __jsx("div", {
    className: "value"
  }, "".concat(targetRate, " ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol))), __jsx(Row, null, __jsx("div", {
    className: "label"
  }, t('remaining_duration')), __jsx("div", {
    className: "value"
  }, "".concat(remainingDays, " / ").concat(totalDays, " ").concat(t('days')))), __jsx(Row, null, __jsx("div", {
    className: "label"
  }, t('order_executed_progress')), __jsx("div", {
    className: "value"
  }, "".concat(formattedAmount(filledInputAmount), " / ").concat(formattedAmount(inputAmount), " ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol))), __jsx(ButtonsWrapper, null, __jsx(DetailButton, {
    onClick: () => handleOpenOrderDetail(formattedOrder),
    disabled: disableDetailButton
  }, t('order_detail')), isInProgress && __jsx(CancelButton, {
    onClick: () => cancelOrder(order)
  }, t('cancel'))));
};

export default Order;